<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newMeeting'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <div class="d-flex justify-content-center mt-3"></div>
      <b-tabs pills vertical>
        <b-tab :title="'حمایت‌های پیشین از نشست'" active>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">حمایت‌های پیشین</h4>
            </template>
            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    initial.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    href="/researcher/rules/meeting/شیوه نامه نشست های تخصصی.pdf"
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از نشست‌های تخصصی ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  id="switch_1"
                  v-model="initial.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>
            <hr />
            <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

            <p>
              به ابزار حمایت از طرح‌های پژوهشی سامانه تقسیم کار ملی خوش آمدید.
              خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              :class="initial.faSubject ? 'done' : 'required'"
              label="عنوان نشست تخصصی"
            >
              <b-form-input trim v-model="initial.faSubject" required>
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
              :class="initial.initialIsSupported !== null ? 'done' : 'required'"
            >
              <b-form-radio-group v-model="initial.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="initial.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="
                initial.initialSupportedType == 'other' &&
                initial.initialIsSupported
              "
              :class="initial.initialOtherSupport ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="initial.initialOtherSupport"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportDescription ? 'done' : 'required'"
            >
              <b-form-textarea
                trim
                rows="6"
                v-model="initial.initialSupportDescription"
              >
              </b-form-textarea>
            </b-form-group>

            <b-form-group
              label="لطفا حامیان برگزاری نشست را معرفی کنید:"
              :class="sponsoritemsClass"
            >
              <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
              <b-button variant="success" class="mb-3 ml-1" @click="add()"
                >+</b-button
              >

              <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="initial.meetingSponsors"
                :fields="sponsorFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="remove(data.index)"
                    >x</b-button
                  >
                </template>

                <template v-slot:cell(name)="data">
                  <b-form-input
                    trim
                    v-model="data.item.name"
                    type="text"
                  ></b-form-input>
                </template>
              </b-table>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab disabled :title="'اطلاعات اصلی نشست'"></b-tab>
        <b-tab disabled :title="'اطلاعات مجری برگزار کننده نشست'"></b-tab>
        <b-tab disabled :title="'اطلاعات برگزار کنندگان'"></b-tab>
        <b-tab disabled :title="'زمانبندی'"></b-tab>
        <b-tab disabled :title="'فایل های تکمیلی'"></b-tab>
        <b-tab disabled :title="'تعهدات'"></b-tab>
        <b-tab disabled :title="'مرور نهایی و ارسال'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.initialObligation ||
            !initial.faSubject ||
            initial.meetingSponsors.length == 0 ||
            initial.meetingSponsors.length !=
              initial.meetingSponsors.map((x) => x.name).filter((y) => y)
                .length ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported &&
              !initial.initialSupportDescription) ||
            (initial.initialIsSupported &&
              initial.initialSupportedType == 'other' &&
              !initial.initialOtherSupport)
          "
          >آغاز فرایند</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site

export default {
  components: {},
  data() {
    return {
      initial: {
        initialIsSupported: null,
        meetingSponsors: [],
      },
      proposal: {},
      sponsoritems: [],
      sponsorFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
        { key: "operation", label: "" },
      ],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
    };
  },

  methods: {
    add() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.initial.meetingSponsors.push({
        name: "",
      });
      this.toast("!حامی جدید افزوده شد", "info");
    },
    remove(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections

      this.initial.meetingSponsors.splice(order, 1);
      this.toast("!حامی حذف شد", "error");
    },
    start() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // NOTE (m-start) to save drafts in each step
      this.isSaving = true;

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/meeting/new",
          {
            initialObligation: this.initial.initialObligation,
            faSubject: this.initial.faSubject,
            meetingSponsors: this.initial.meetingSponsors,
            initialIsSupported: this.initial.initialIsSupported,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.initialOtherSupport,
            initialSupportDescription: this.initial.initialSupportDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          router.push("/researcher/completeMeeting/" + res.data);
          const title = (
            <div>
              <h5>!ثبت پیشنویس</h5>
              <span>
                پیشنویس ثبت شد. برای ثبت نهایی تکمیل کلیه اطلاعات و زدن دکمه
                ارسال الزامی است
              </span>
            </div>
          );
          this.toast(title, "info");
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
  },
  computed: {
    sponsoritemsClass() {
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.initial.meetingSponsors) {
        total += this.initial.meetingSponsors.length;
        this.initial.meetingSponsors.forEach((x) => {
          x.name ? progress++ : 1;
        });
        if (total / progress == 1) {
          return "done";
        } else {
          return "required";
        }
      } else {
        return "required";
      }
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
